import { Image, StyleSheet, View } from '@react-pdf/renderer';
import logo from '../../../assets/image/system/logo.png';

const styles = StyleSheet.create({
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  logo: {
    height: 30,
    width: 'auto',
  },
});

export const RoastProfileLogo = () => (
  <View style={styles.logoContainer}>
    <Image src={logo} style={styles.logo} />
  </View>
);
